import _ from "lodash";
import FormControl from "./FormControl";
import { InputLabel, Box } from "@mui/material";

export default function FormControlWithSubFields({
  text: label,
  subFields,
  userResponse,
  onResponseChange,
  IDX,
  VIEWMODE,
  disabledAll,
  isInsideChecklist,
  SAVE,
  bgClassName,
  setValidate,
  PQCLIENTID,
  editAccess,
  isBold,
  ...field
}) {
  const validateSubField = (subSecField, r, isRequired) => {
    var subFieldId = _.split(subSecField, '-')
    setValidate != undefined && setValidate(field?.id, r, isRequired, subFieldId[1]);
  };
  return (
    <Box
      className={`form-control-with-sub-fields 
      ${field.labelPositioning || "vertical"} 
      ${!isInsideChecklist && field.fieldPositioning == 'horizontal' ? "d-flex flex-wrap" : "px-0 py-1"}`}
    >
      {label && (
        <Box className={`label-container ${!isInsideChecklist && field.fieldPositioning == 'horizontal' ? "w-100 " : ""}`}>
          <InputLabel
            disabled={disabledAll}
            className={`input-label ${field.isBold ? "input-label font-weight-bold" : "input-label"
              }`}
          >
            <span style={{ fontWeight: isBold == true ? "bold" : "", color: "black" }}>{label}</span>
            {field.required && <sup>*</sup>}
          </InputLabel>
        </Box>
      )}
      {subFields?.map((sf) => (
        <FormControl
          bgClassName={bgClassName}
          isInsideChecklist={isInsideChecklist}
          key={`${field?.id}-${sf?.id}`}
          fieldId={`${field?.id}-${sf?.id}`}
          required={sf?.required}
          inputType={sf?.inputType}
          editAccess={editAccess}
          VIEWMODE={VIEWMODE}
          multiple={sf?.multiple}
          items={sf.options}
          checked={userResponse[IDX][field?.id]?.[sf?.id] == "true"}
          value={userResponse[IDX][field?.id]?.[sf?.id] || ""}
          handleChange={(value) =>
            onResponseChange(field?.id, { [sf?.id]: value }, sf?.id)
          }
          placeHolder={sf?.questionPlaceholder}
          fieldPositioning={field?.fieldPositioning || "horizontal"}
          width={sf?.width}
          disabled={disabledAll || sf?.disabled || sf?.qFormula}
          SAVE={SAVE}
          buttonTypeReferenceValue={sf?.ButtonTypeReferenceValue}
          TableRefFieldValueDisplay={sf?.TableRefFieldValueDisplay}
          TableReference={sf?.TableReference}
          TableReferenceField={sf?.TableReferenceField}
          Reference={sf?.Reference}
          setValidate={validateSubField}
          PQCLIENTID={PQCLIENTID}
          isLinked={sf?.isLinked}
        />
      ))}
    </Box>
  );
}
